import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { getNonLouielogic } from "../../louie/NonLouielogic/NonLouielogicSlice";


export function MyLouieTasksCarousel(props: any) {
  const navigateMyLouieTasks = useNavigate();
  const navigateToMyLouieTasks = () => {
    navigateMyLouieTasks("/mylouietasks");
  };
  const NonLouielogicflag = useSelector(getNonLouielogic);




  return (
    <>

      <div className="card border-0 mb-0 pb-0" onClick={navigateToMyLouieTasks} style={{ cursor: "pointer" }}>
        <img
          src={props.web_url}
          className="w-100 desktopImage"
          alt="My Louie Task"
        />
        <img
          src={props.mobile_url}
          className="w-100 mobileImage"
          alt="My Louie Task"
        />
        <div className="card-img-overlay text-end">
          <div className="row mb-4">
            <div className="col-md-12 pt-3 text-end me-5 pe-4">
              <div className="template">
                <Button
                  className="me-0 mb-5"
                  onClick={() => navigateToMyLouieTasks()}
                >
                  My Louie Tasks
                </Button>

                <h2 className="position-absolute bottom-0 text-end mb-5 end-0 pe-4">
                  Complete My Louie Tasks
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
